import React, { Component } from 'react'
import { connect } from 'react-redux'
import async from 'async'
import moment from 'moment'

import { API_URL, FILE_STORAGE, FILE_STORAGE_API } from '../../../constants'

// import components
import Header from '../../../shared/components/Header'

// import components
import Dropzone from '../../../shared/components/Dropzone'
import Gallery from '../../../shared/components/Gallery'
import Portal from '../../../shared/components/Portal'
import Confirm from '../../../shared/components/Confirm'

// Actions
import { getMessage, createUpdateMessage, fileUpload, fileDelete } from '../../../actions/messages'

// Utils
import { translation } from '../../../utils/helpers'
// import { renderFullDate } from '../../../utils/time'
import { hasAccess } from '../../../utils/auth'

// Elements
import Button from '../../../shared/elements/button'
import BackButton from '../../../shared/elements/backButton'
import Text from '../../../shared/elements/text'
import LabelWrapper from '../../../shared/elements/labelWrapper'
import DateTime from '../../../shared/elements/datetime'
import DropDown from '../../../shared/elements/dropDown'
import Panel from '../../../shared/elements/panel'
import Textarea from '../../../shared/elements/textarea'
import Check from '../../../shared/elements/check'
// import Row from '../../../shared/elements/row'
import Col from '../../../shared/elements/col'
import Inline from '../../../shared/elements/inline'
import Radio from '../../../shared/elements/radio'
import Divider from '../../../shared/elements/divider'
import RemoveButton from '../../../shared/elements/removeButton'

// import styles
import '../messages.scss'
import './message.scss'

class Single extends Component {

  constructor (props) {
    super(props)
    this.state = {
      View: 'List',
      CheckAll: false,
      message: {
        Id: Number(this.props.params.messagesID),
        Type: 0,
        Title: '',
        Subtitle: '',
        Body: '',
        CreationDate: '',
        StartDate: moment(),
        DeletedDate: null,
        ExpireDate: moment().add(1, 'd'),
        CompanyId: Number(this.props.auth.user.ShopId),
        SenderId: 0,
        IsSent: false,
        MessageUsers: [],
        MessageCompanies: [],
        MessageTargets: [],
        MessageFiles: [],
        MessageIllustration: null,
        MessageDocument: null
      },
      upload: {
        loading: false,
        errors: []
      },
      illustrationUpload: {
        loading: false,
        errors: []
      },
      documentUpload: {
        loading: false,
        errors: []
      },
      employees: [],
      companies: [],
      targets: {},
      MessageFiles: [],
      confirmFileDelete: {
        confirm: false,
        file: null
      }
    }
    this.onChange = this.onChange.bind(this)
    this.onCheckAll = this.onCheckAll.bind(this)
    this.onCheck = this.onCheck.bind(this)
    this.onCheckTarget = this.onCheckTarget.bind(this)
    this.updateMessage = this.updateMessage.bind(this)
    this.onChangeStartDate = this.onChangeStartDate.bind(this)
    this.onChangeExpireDate = this.onChangeExpireDate.bind(this)
    this.deleteConfirmation = this.deleteConfirmation.bind(this)
    this.deleteFile = this.deleteFile.bind(this)
    this.renderFile = this.renderFile.bind(this)
    this.renderImage = this.renderImage.bind(this)
    this.renderSaveButton = this.renderSaveButton.bind(this)
  }

  componentDidMount () {
    // get message
    if (this.props.params.messagesID > 0) {
      this.getMessageById(this.props.params.messagesID)
    }
  }

  updateMessage (e, goThrough) {
    if (this.state.message.Id === 0 && typeof goThrough === 'undefined') return null
    // check input
    // console.log('UpdateMessage', this.state.message)
    if (this.state.message.Title.length > 0// &&
        // this.state.message.StartDate !== '' &&
        // this.state.message.ExpireDate !== '' &&
        // (this.state.message.MessageCompanies.length > 0 || this.state.message.MessageUsers)
      ) {
      // convert dates
      const formatDate = (date) => {
        if (!date) return '1990-01-01T00:00:00'
        if (typeof date.format === 'function') {
          return date.format('YYYY-MM-DDTHH:mm:ss')
        }
        return date
      }

      let message = {...this.state.message}
      message.StartDate = formatDate(message.StartDate)
      message.ExpireDate = formatDate(message.ExpireDate)

      // add company
      if (this.props.auth.user.UserType === 3 && message.MessageCompanies.length === 0) {
        message.MessageCompanies = [
          {CompanyId: Number(this.props.auth.user.ShopId)}
        ]
      }
      // Images
      if (this.state.MessageFiles.length !== 0) {
        message.MessageFiles = message.MessageFiles.concat(this.state.MessageFiles)
      }
      // update / add message
      this.props.createUpdateMessage(message).then((res) => {
        // Toastr
        // window.toastr.success(translation('1826'), translation('13424'))
        this.setState({
          message: res.data,
          MessageFiles: []
        }, () => {
          if (message.Id === 0) {
            this.props.router.replace('/messages/' + res.data.Id)
          }
        })
      }, (err) => {
        // Toastr
        if (err.response !== undefined && err.response.data !== undefined) {
          console.log('err', err)
          window.toastr.error(translation(err.response.data.DictionaryKey), translation('216'))
        } else {
          window.toastr.error(translation('1827'), translation('216'))
        }
      })
    } else {
      if (this.state.message.Title.length < 1) {
        // Toastr
        window.toastr.error(translation('13009'), translation('216'))
      }
      // if (this.state.message.MessageUsers.length < 1) {
      //   window.toastr.error(translation('1026'), translation('216'))
      // }
    }
  }

  getMessageById (id) {
    this.props.getMessage(id).then((res) => {
      // Target
      var lengthTarget = res.data.MessageTargets.length
      var rowStateTarget = {}
      for (var i = 0; i < lengthTarget; i++) {
        rowStateTarget[res.data.MessageTargets[i].Target] = true
      }
      // Companies
      var lengthCom = res.data.MessageCompanies.length
      var rowStateCom = []
      for (var x = 0; x < lengthCom; x++) {
        rowStateCom[res.data.MessageCompanies[x].CompanyId] = true
      }
      // Employees
      var lengthEm = res.data.MessageUsers.length
      var rowStateEm = []
      for (var y = 0; y < lengthEm; y++) {
        rowStateEm[res.data.MessageUsers[y].UserId] = true
      }
      this.setState({
        message: res.data,
        targets: rowStateTarget,
        companies: rowStateCom,
        employees: rowStateEm
      })
    }, (err) => {
      console.log(err)
    })
  }

  onChange ({ target: { name, value } }) {
    let val = value

    if (name === 'Type') {
      val = parseInt(value, 10)

      this.setState({
        message: {
          ...this.state.message,
          [name]: val,
          MessageTargets: []
        },
        targets: {}
      }, this.updateMessage)
    }

    this.setState({
      message: {
        ...this.state.message,
        [name]: val
      }
    })
  }

  onCheckTarget ({ target: { value, checked } }) {
    this.setState({
      targets: {
        ...this.state.targets,
        [value]: checked
      }
    })

    if (checked) {
      var msgTarget = {
        Target: Number(value),
        MessageId: Number(this.state.message.Id)
      }
      this.state.message.MessageTargets.push(msgTarget)
      this.setState({
        message: {
          ...this.state.message,
          MessageTargets: [
            ...this.state.message.MessageTargets
          ]
        }
      }, this.updateMessage)
    } else {
      var msgTargets = this.state.message.MessageTargets
      this.state.message.MessageTargets = msgTargets.filter(mt =>
        mt.Target !== Number(value)
      )
      this.setState({
        message: {
          ...this.state.message,
          MessageTargets: [
            ...this.state.message.MessageTargets
          ]}
      }, this.updateMessage)
    }
  }

  onCheckAll ({ target: { checked } }) {
    this.setState({ CheckAll: checked })

    if (this.props.auth.user.UserType === 2) {
      // map companies
      var CheckAllCompanies = []
      var CheckAllMessageCompanies = []
      this.props.companies.map(function (comp) {
        CheckAllCompanies[comp.ShopId] = checked
        if (checked) {
          var CheckAllMessageCompaniesValue = {
            MessageId: 0,
            CompanyID: comp.ShopId
          }
          CheckAllMessageCompanies.push(CheckAllMessageCompaniesValue)
        } else {
          CheckAllMessageCompanies = []
        }
      })
      this.setState({
        companies: CheckAllCompanies,
        message: {
          ...this.state.message,
          MessageCompanies: CheckAllMessageCompanies
        }
      }, this.updateMessage)
    } else if (this.props.auth.user.UserType === 3) {
      // map employees
      var CheckAllEmployees = []
      var CheckAllMessageEmployees = []
      this.props.employees.map(function (emp) {
        CheckAllEmployees[emp.UserId] = checked
        if (checked) {
          var CheckAllMessageEmployeesValue = {
            IsRead: false,
            MessageId: 0,
            UserId: emp.UserId
          }
          CheckAllMessageEmployees.push(CheckAllMessageEmployeesValue)
        } else {
          CheckAllMessageEmployees = []
        }
      })
      this.setState({
        employees: CheckAllEmployees,
        message: {
          ...this.state.message,
          MessageUsers: CheckAllMessageEmployees
        }
      }, this.updateMessage)
    }
  }

  onCheck ({ target: { value, checked, id } }) {
    // Chain
    if (this.props.auth.user.UserType === 2) {
      this.setState({
        companies: {
          ...this.state.companies,
          [value]: checked
        }
      })
      if (checked) {
        var msgComp = {
          CompanyId: Number(id),
          IsRead: false,
          MessageId: Number(this.state.message.Id)
        }
        this.state.message.MessageCompanies.push(msgComp)
        this.setState({
          message: {
            ...this.state.message,
            MessageCompanies: [
              ...this.state.message.MessageCompanies
            ]
          }
        }, () => {
          this.updateMessage()
          this.setState({ CheckAll: checkAll() })
        })
      } else {
        var msgComps = this.state.message.MessageCompanies
        this.state.message.MessageCompanies = msgComps.filter(mc =>
          mc.CompanyId !== Number(id)
        )
        this.setState({
          message: {
            ...this.state.message,
            MessageCompanies: [
              ...this.state.message.MessageCompanies
            ]
          }
        }, () => {
          this.updateMessage()
          this.setState({ CheckAll: checkAll() })
        })
      }
    } else {
      // Company
      this.setState({
        employees: {
          ...this.state.employees,
          [value]: checked
        }
      })
      if (checked) {
        var msgUser = {
          UserId: Number(id),
          IsRead: false,
          MessageId: Number(this.state.message.Id)
        }
        this.state.message.MessageUsers.push(msgUser)
        this.setState({
          message: {
            ...this.state.message,
            MessageUsers: [
              ...this.state.message.MessageUsers
            ]
          }
        }, () => {
          this.updateMessage()
          this.setState({ CheckAll: checkAll() })
        })
      } else {
        var msgUsers = this.state.message.MessageUsers
        this.state.message.MessageUsers = msgUsers.filter(mu =>
          mu.UserId !== Number(id)
        )
        this.setState({
          message: {
            ...this.state.message,
            MessageUsers: [
              ...this.state.message.MessageUsers
            ]
          }
        }, () => {
          this.updateMessage()
          this.setState({ CheckAll: checkAll() })
        })
      }
    }
    const checkAll = () => {
      // Is all checked?
      let allChecked = true
      if (this.props.auth.user.UserType === 2) {
        let companies = this.state.companies
        for (let i = 0; i < this.props.companies.length; i++) {
          let comp = this.props.companies[i]
          if (companies[comp.CompanyId] !== true) {
            allChecked = false
            break
          }
        }
      } else {
        let employees = this.state.employees
        for (let i = 0; i < this.props.employees.length; i++) {
          let emp = this.props.employees[i]
          if (employees[emp.UserId] !== true) {
            allChecked = false
            break
          }
        }
      }
      return allChecked
    }
  }

  messageCheckboxExtra (isNews = false) {
    if (this.props.auth.user.UserType === 2) {
      const renderRole = (name, value, label, disabled) => {
        return (
          <Check labelText={translation(label)} id={name} value={value} name={name} checked={this.state.targets[value]} onChange={this.onCheckTarget} disabled={disabled} />
        )
      }

      return (
        <Panel title={translation('2707')}>
          {renderRole('admin', 1, '61', isNews)}
          {renderRole('leader', 2, '646', isNews)}
          {renderRole('employee', 3, '64', isNews)}
          {renderRole('driver', 4, '647', isNews)}
          {isNews && <Divider />}
          {isNews && renderRole('customerContacts', 5, '15288')}
          {/* <div className='checkbox__custom control__field'>
            <input type='checkbox' id='admin' value='1' name='admin' checked={this.state.targets[1]} onChange={this.onCheckTarget} />
            <label htmlFor='admin'>{translation('61')}</label>
          </div>
          <div className='checkbox__custom control__field'>
            <input type='checkbox' id='leader' value='2' name='leader' checked={this.state.targets[2]} onChange={this.onCheckTarget} />
            <label htmlFor='leader'>{translation('646')}</label>
          </div>
          <div className='checkbox__custom control__field'>
            <input type='checkbox' id='employee' value='3' name='employee' checked={this.state.targets[3]} onChange={this.onCheckTarget} />
            <label htmlFor='employee'>{translation('64')}</label>
          </div>
          <div className='checkbox__custom control__field'>
            <input type='checkbox' id='driver' value='4' name='driver' checked={this.state.targets[4]} onChange={this.onCheckTarget} />
            <label htmlFor='driver'>{translation('647')}</label>
          </div> */}
        </Panel>
      )
    }
    return null
  }

  renderRecipientList () {
    const employeesList = (emp, key) => {
      if (!emp.Active) return null
      const checked = (typeof this.state.employees[emp.UserId] !== 'undefined' && this.state.employees[emp.UserId])
      return (
        <Check key={key} labelText={emp.Name} id={emp.UserId} value={emp.UserId} name={key} checked={checked} onChange={this.onCheck} />
      )
    }
    const companiesList = (comp, key) => {
      const checked = (typeof this.state.companies[comp.ShopId] !== 'undefined' && this.state.companies[comp.ShopId])
      return (
        <Check key={key} labelText={comp.ShopName} id={comp.ShopId} value={comp.ShopId} name={key} checked={checked} onChange={this.onCheck} />
      )
    }
    const headline = () => {
      if (this.props.auth.user.UserType === 2) {
        return translation('4')
      } else {
        return translation('10')
      }
    }
    const checkList = () => {
      if (this.props.auth.user.UserType === 2) {
        return (<div>{this.props.companies.map(companiesList)}</div>)
      } else {
        return (<div>{this.props.employees.map(employeesList)}</div>)
      }
    }

    return (
      <Panel title={headline()}>
        <Check labelText={translation('531')} id='all' onChange={this.onCheckAll} checked={this.state.CheckAll} />
        {checkList()}
      </Panel>
    )
  }

  deleteConfirmation (file) {
    this.setState({
      confirmFileDelete: {
        confirm: true,
        file
      }
    })
  }

  deleteFile ({ OrderFileID, FileName }) {
    let newErrors = []

    this.props.fileDelete({ ItemId: OrderFileID })
      .then(() => {
        // Delete from database
        let MessageFiles = [...this.state.message.MessageFiles]
        MessageFiles = MessageFiles.filter(mf =>
          mf.OrderFileID !== Number(OrderFileID)
        )

        this.setState({
          message: {
            ...this.state.message,
            MessageFiles
          }
        }, this.updateMessage)
      }, () => {
        newErrors.push(translation('1207') + ': ' + FileName)
        this.setState({
          upload: { ...this.state.upload, errors: newErrors }
        })
      })
  }

  renderFile (file, index) {
    const newFileUrl = FILE_STORAGE_API + '/FileService/DownloadNoHeader?fileName=' + file.FileNameWithFolders + '&token=' + encodeURIComponent(this.props.auth.user.Token)
    const thumbUrl = API_URL + '/FileService/GetIcon?fileName=' + file.FileNameWithFolders
    return (
      <Inline key={index} block>
        <img className='file-icon' alt='icon' src={thumbUrl} />
        <a target='_BLANK' href={newFileUrl}>
          {file.FileName}
        </a>
        {this.props.auth.user.CustomerId === '-1' && <RemoveButton size='s' bin onClick={() => this.deleteConfirmation(file)} />}
      </Inline>
    )
  }

  renderImage (image, index) {
    const url = FILE_STORAGE + image.ThumbURL
    const fullUrl = FILE_STORAGE + image.FileURL
    return (
      <div className='image-div' key={index}>
        <a href={fullUrl} data-lightbox='gallery' data-title={image.FileName}><img src={url} /></a>
        {this.props.auth.user.CustomerId === '-1' && <RemoveButton size='s' onClick={() => this.deleteConfirmation(image)} />}
      </div>
    )
  }

  renderFiles () {
    const { errors } = this.state.upload

    // On drop
    const onDrop = () => {
      this.setState({ upload: {
        ...this.state.upload,
        errors: []
      } })
    }
    // On drop accepted
    const onDropAccepted = (files) => {
      let newErrors = []
      let MessageFiles = []
      this.setState({
        upload: {
          ...this.state.upload,
          loading: true
        }
      })
      async.each(files, (file, cb) => {
        // Upload each file
        this.props.fileUpload(file).then(({ data }) => {
          MessageFiles.push({
            FileName: data[0].FileName,
            FileURL: data[0].RealFileURL,
            ThumbURL: data[0].RealThumbURL,
            Description: '',
            CreationDate: file.lastModifiedDate,
            OrderFileID: data[0].OrderFileID,
            IsImage: data[0].IsImage
          })
          cb()
        }, () => {
          newErrors.push(translation('1207') + ': ' + file.name + ' ' + translation('13406') + '.')
          cb()
        })
      }, () => {
        if (newErrors.length !== 0) {
          this.setState({
            upload: {
              ...this.state.upload,
              errors: this.state.upload.errors.concat(newErrors)
            },
            MessageFiles: []
          }, this.updateMessage)
        } else {
          let message = {...this.state.message}
          message.MessageFiles = message.MessageFiles.concat(MessageFiles)
          this.setState({
            message: message,
            upload: {
              ...this.state.upload,
              loading: false
            },
            MessageFiles: [] // MessageFiles
          }, this.updateMessage)
        }
      })
    }
    // On drop rejected
    const onDropRejected = (files) => {
      let newErrors = []
      files.map((file) => {
        newErrors.push(translation('1207') + ': ' + file.name + ' ' + translation('13405') + '.')
      })
      this.setState({ upload: { ...this.state.upload, errors: newErrors } })
    }
    // Render error
    const renderError = (error, index) => {
      return <p key={index}>{error}</p>
    }

    // // imgFiles
    // let imgFiles = [...this.state.message.MessageFiles].filter(file => file.IsImage)
    // // Doc files
    // let docFiles = [...this.state.message.MessageFiles].filter(file => !file.IsImage)
    let imgFiles = []
    let docFiles = []
    this.state.message.MessageFiles.forEach(file =>
      file.IsImage
      ? imgFiles.push(file)
      : docFiles.push(file)
    )

    let multiple = true
    // Render
    return (
      <LabelWrapper labelText={translation('1043')}>
        {errors.length !== 0 && <div className='alert alert-danger'>{errors.map(renderError)}</div>}
        <Dropzone
          onDrop={onDrop}
          onDropAccepted={onDropAccepted}
          onDropRejected={onDropRejected}
          multiple={multiple}
          includeCircles={false}>
          {this.state.upload.loading && (
            <p className='loading'>
              <span className='animated-background'>
                <i className='fa fa-spinner fa-spin fa-3x fa-fw' />
                <span className='sr-only'>{translation('13382')}...</span>
              </span>
            </p>
          )}
          {!this.state.upload.loading && (
            <div><p>{translation('13397')}</p></div>
          )}
        </Dropzone>
        <div className='clearfix'>
          <div className='gallery'>
            <ul className='files_inner'>
              {docFiles.map(this.renderFile)}
            </ul>
          </div>
          <Gallery files={imgFiles} renderImage={this.renderImage} />
        </div>
      </LabelWrapper>
    )
  }

  renderIllustration () {
    const renderDropzone = (isIllustration = false) => {
      let uploadName
      let upload
      let type
      if (isIllustration) {
        uploadName = 'illustrationUpload'
        upload = this.state.illustrationUpload
        type = 17
      } else {
        uploadName = 'documentUpload'
        upload = this.state.documentUpload
        type = 18
      }

      const onDrop = () => this.setState({ [uploadName]: { errors: [] } })
      const onDropAccepted = (files) => {
        let newErrors = []
        let newFiles = []
        this.setState({
          [uploadName]: {
            ...this.state[uploadName],
            loading: true
          }
        })
        async.each(files, (file, cb) => {
          // Upload each file
          this.props.fileUpload(file, type).then(({ data }) => {
            newFiles.push({
              FileName: data[0].FileName,
              FileURL: data[0].RealFileURL,
              ThumbURL: data[0].RealThumbURL,
              Description: '',
              CreationDate: file.lastModifiedDate,
              OrderFileID: data[0].OrderFileID,
              IsImage: data[0].IsImage
            })
            cb()
          }, (err) => {
            window.toastr.error(translation(err.response.data.DictionaryKey), translation('216'))
            newErrors.push(translation('1207') + ': ' + file.name + ' ' + translation('13406') + '.')
            cb()
          })
        }, () => {
          if (newErrors.length !== 0) {
            this.setState({
              [uploadName]: {
                ...this.state[uploadName],
                errors: this.state[uploadName].errors.concat(newErrors),
                loading: false
              },
              MessageFiles: []
            }, this.updateMessage)
          } else {
            let message = { ...this.state.message }
            // message.MessageFiles = message.MessageFiles.concat(newFiles)

            if (isIllustration) {
              message.MessageIllustration = newFiles[0]
            } else {
              message.MessageDocument = newFiles[0]
            }

            this.setState({
              message: message,
              [uploadName]: {
                ...this.state[uploadName],
                loading: false
              },
              MessageFiles: [] // MessageFiles
            }, this.updateMessage)
          }
        })
      }
      const onDropRejected = (files) => {
        const errors = files.map(file => {
          return `${translation('1207')}: ${file.name} ${translation('13405')}.`
        })

        this.setState({
          illustrationUpload: {
            errors: errors
          }
        })
      }

      const renderDropzoneContent = () => {
        const isLoading = upload.loading

        if (isLoading) {
          return (
            <p className='loading'>
              <span className='animated-background'>
                <i className='fa fa-spinner fa-spin fa-3x fa-fw' />
                <span className='sr-only'>{translation('13382')}...</span>
              </span>
            </p>
          )
        }

        return (
          <div><p>{translation('13397')}</p></div>
        )
      }

      const title = isIllustration ? '15285' : '15286'
      const msgDocument = this.state.message.MessageDocument ? [ this.state.message.MessageDocument ] : []
      const msgIllustration = this.state.message.MessageIllustration ? [ this.state.message.MessageIllustration ] : []

      return (
        <LabelWrapper labelText={translation(title)}>
          <Dropzone
            onDrop={onDrop}
            onDropAccepted={onDropAccepted}
            onDropRejected={onDropRejected}
            multiple={false}
            includeCircles={false}
          >
            {renderDropzoneContent()}
          </Dropzone>
          {!isIllustration && (
            <div className='gallery'>
              <ul className='files_inner'>
                {msgDocument.map(this.renderFile)}
              </ul>
            </div>
          )}
          {isIllustration && <Gallery files={msgIllustration} renderImage={this.renderImage} />}
        </LabelWrapper>
      )
    }

    return (
      <div>
        {renderDropzone(true)}
        {renderDropzone(false)}
      </div>
    )
  }

  renderStartDate () {
    const { StartDate } = this.state.message
    let times = []
    for (let h = 0; h < 24; h++) {
      let hour = h < 10 ? '0' + h : h.toString()
      times.push(hour + ':00')
      times.push(hour + ':30')
    }
    // Time string
    let timeString = times ? times[0] : ''
    // Date
    let date = StartDate ? window.CustomDate(StartDate) : ''

    if (date !== '') {
      // Hours + pad zero
      let hours = date.getHours()
      // Minutes + pad zero
      let minutes = date.getMinutes()
      if (minutes === 0) {
        minutes = '00'
      } else if (minutes <= 30) {
        minutes = '30'
      } else {
        minutes = '00'
        hours = '00'.substring(0, 2 - hours.length) + (hours + 1)
      }

      if (typeof hours !== 'string') {
        const end = hours > 9 ? 2 : 1
        hours = '00'.substring(0, 2 - end) + hours
      }

      // Set time
      timeString = `${hours}:${minutes}`
    }
    // Actions
    const onChangeTime = ({ target: { value } }) => {
      const splitted = value.split(':')
      const dateVal = (StartDate !== null) ? window.CustomDate(StartDate) : window.CustomDate()
      let momentDate = moment(dateVal)
      momentDate.set({hour: splitted[0], minute: splitted[1], second: 0, millisecond: 0})
      this.setState({
        message: {
          ...this.state.message,
          StartDate: momentDate
        }
      }, this.updateMessage)
    }

    const inputProps = {
      name: 'startDate',
      readOnly: true
    }
    let closeOnSelect = true
    // Return
    let timeKey = 'Pickup_' + moment(date).format('DD-MM-YYYY_HH:mm')
    return (
      <LabelWrapper labelText={translation('1490')}>
        <Inline>
          <DateTime
            inputProps={inputProps}
            dateFormat='DD-MM-YYYY'
            closeOnSelect={closeOnSelect}
            value={date}
            timeFormat={false}
            // onChange={onChangeStartDate.bind(this.state)} />
            onChange={this.onChangeStartDate} />
          <DropDown value={timeString} onChange={onChangeTime} key={timeKey}>
            {times.map((val, index) => {
              return (<option key={index} value={val}>{val}</option>)
            })}
          </DropDown>
        </Inline>
      </LabelWrapper>
    )
  }

  onChangeStartDate (StartDate) {
    const { ExpireDate } = this.state
    let shouldExpireDateUpdate = false
    let newExpireDate = null
    if (StartDate.isSameOrAfter(ExpireDate)) {
      shouldExpireDateUpdate = true
      newExpireDate = StartDate.clone().add(1, 'd')
    }
    this.setState({
      message: {
        ...this.state.message,
        StartDate,
        ...shouldExpireDateUpdate && { ExpireDate: newExpireDate }
      }
    }, this.updateMessage)
  }

  onChangeExpireDate (ExpireDate) {
    this.setState({
      message: {
        ...this.state.message,
        ExpireDate
      }
    }, this.updateMessage)
  }

  renderTypes () {
    if (!hasAccess([2], this.props.auth.user.UserType)) return null

    return (
      <LabelWrapper labelText={translation('332')}>
        <Radio labelText={translation('930')} id='message' name='Type' value={0} onChange={this.onChange} checked={this.state.message.Type === 0} />
        <Radio labelText={translation('15283')} id='news' name='Type' value={1} onChange={this.onChange} checked={this.state.message.Type === 1} />
      </LabelWrapper>
    )
  }

  renderExpireDate () {
    const { ExpireDate } = this.state.message

    // Date
    let renderExpireDate = ''
    if (ExpireDate) {
      renderExpireDate = window.CustomDate(ExpireDate)
    }
    const inputProps = {
      placeholder: translation('1728'),
      readOnly: true
    }

    return (
      <LabelWrapper labelText={translation('1245')}>
        <DateTime
          inputProps={inputProps}
          dateFormat='DD-MM-YYYY'
          timeFormat={false}
          closeOnSelect
          value={renderExpireDate}
          onChange={this.onChangeExpireDate} />
      </LabelWrapper>
    )
  }

  renderSaveButton (isNews = false) {
    if (this.state.message.Id !== 0) return null
    return (
      <Button onClick={this.updateMessage.bind(this, 'yes')} labelText={translation(isNews ? '15287' : '2047')} />
    )
  }

  render () {
    const onConfirm = () => {
      const file = this.state.confirmFileDelete.file
      this.setState({
        confirmFileDelete: {
          confirm: false,
          file: null
        }
      }, () => {
        this.deleteFile(file)
      })
    }

    const notConfirm = () => {
      this.setState({
        confirmFileDelete: {
          confirm: false,
          file: null
        }
      })
    }

    const isNews = this.state.message.Type === 1

    const renderGoBack = () => {
      const goBack = () => {
        this.props.router.replace({
          pathname: '/messages'
        })
      }
      return (
        <div>
          <BackButton onClick={goBack} ariaText={translation('394')} />
        </div>
      )
    }
    return (
      <div>
        <Header router={this.props.router} showBack headerButtonsGoBack={renderGoBack} />
        <div className='messages__screen--inner'>
          <Col>
            <Panel title={translation('930')}>
              {this.renderTypes()}
              <Text labelText={translation('1229')} name='Title' value={this.state.message.Title} onChange={this.onChange} onBlur={this.updateMessage} />
              {isNews && (
                <Text labelText={translation('15284')} name='Subtitle' value={this.state.message.Subtitle} onChange={this.onChange} onBlur={this.updateMessage} />
              )}
              {this.renderStartDate()}
              {this.renderExpireDate()}
              <Textarea labelText={translation('1021')} name='Body' value={this.state.message.Body} onChange={this.onChange} onBlur={this.updateMessage} />
              {isNews && this.renderIllustration()}
              {!isNews && this.renderFiles()}
              {this.renderSaveButton(isNews)}
            </Panel>
            {this.messageCheckboxExtra(isNews)}
          </Col>
          <Col>
            {this.renderRecipientList()}
          </Col>
          {this.state.confirmFileDelete.confirm && (
            <Portal className='deleteModal' onPortalClose={notConfirm}>
              <Confirm confirm={onConfirm} notConfirm={notConfirm} />
            </Portal>
          )}
        </div>
      </div>
    )
  }

}

function mapStateToProps (state) {
  return {
    auth: state.auth,
    employees: state.common.employees,
    companies: state.common.companies
  }
}

export default connect(mapStateToProps, {
  getMessage,
  createUpdateMessage,
  fileUpload,
  fileDelete
})(Single)



// WEBPACK FOOTER //
// ./src/app/pages/Messages/Message/index.js